import React, { useRef } from 'react'
import { Mesh, Vector3 } from 'three'
import { useFrame } from '@react-three/fiber'

export function DebugCrosshairComponent({ position }: { position: Vector3 | null }) {
  const meshRef = useRef<Mesh>(null!)

  useFrame(() => {
    if (position && meshRef.current) {
      meshRef.current.position.copy(position)
      meshRef.current.visible = true
    } else if (meshRef.current) {
      meshRef.current.visible = false
    }
  })

  return <>
    <mesh ref={meshRef}>
      <sphereGeometry args={[0.05, 16, 16]} />
      <meshBasicMaterial color="red" />
    </mesh>
  </>
}
